import { Stack, SxProps, Theme, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

import { Card } from '@/components/layout/Card/Card';
import { ContextualHelpTrigger } from '@/modules/content/components/ContextualHelpTrigger';

export function ClientDetailsOverviewPageCard({
  children,
  includeHelpContentTrigger,
  sx = {},
}: PropsWithChildren<{
  includeHelpContentTrigger?: boolean;
  sx?: SxProps<Theme>;
}>) {
  const theme = useTheme();
  return (
    <Card
      variant="outlined"
      sx={{
        height: '100%',
        pb: 2,
        borderRadius: '6px',
        ...sx,
      }}
    >
      <Stack height="100%">
        {includeHelpContentTrigger && (
          <Stack
            direction="row"
            justifyContent="end"
            position="relative"
            top={theme.spacing(1)}
            right={theme.spacing(1)}
          >
            <ContextualHelpTrigger contextualHelpId="howIsThisCalculated" />
          </Stack>
        )}
        {children}
      </Stack>
    </Card>
  );
}
